import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(8, 0, 6, 8),
    gap: theme.spacing(2)
  },
  centerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(8, 0, 6, 8),
    gap: theme.spacing(2)
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 4),
    gap: theme.spacing(2)
  },
  icon: {
    width: 64,
    height: 64,
    marginBottom: theme.spacing(2)
  },
  greenLabel: {
    textAlign: 'center',
    marginRight: theme.spacing(2)
  },
  collapsible: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.colorPalette.beige_25,
    borderRadius: theme.spacing(1),
    boxShadow: 'none'
  },
  noTasksMessage: {
    borderTop: `1px solid ${theme.onCardDivider.green_75_op_30}`,
    padding: theme.spacing(6),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  }
}));
